<h3 *ngIf="showInlineTitle" >{{panelTitle}}</h3>
<ng-container *ngFor="let valueModel of valuesModel.values; let ii = index;">
  
  <div class="row codes-row" [class.alt-row]="(ii+1) % 2 == 0">

    <div *ngIf="calcVisible" class="col">

      <panel-codes-renderer *ngIf="valueModel.calcValue"
                                 [codeValue]="valueModel.calcValue"                                 
                                 [panelId]="valuesModel.panelId">

      </panel-codes-renderer>

    </div>

    <div *ngIf="storedVisible" class="col">

      <panel-codes-renderer *ngIf="valueModel.storedValue"
                                 [codeValue]="valueModel.storedValue"                                 
                                 [panelId]="valuesModel.panelId"
                                 [subHeading]="calcVisible && strings.Stored"
                                 [isStored]="true">

      </panel-codes-renderer>

    </div>

  </div>
</ng-container>
